<template>
  <div class="modal-box">
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>{{ $t('queue.delete') }}</h3>
    </div>
    <div class="modal-content">
      <div class="edit-queue">
        <form
          id="form-delete-queue"
          action=""
        >
          <p>{{ $t('queue.delete.description') }} <strong>"{{ queue.letter.toUpperCase() }} - {{ queue.name[$i18n.locale()] }}"</strong>, e todas as senhas a ela associadas.</p>

          <div class="form-actions">
            <button
              type="button"
              class="btn-secondary"
              @click="close"
            >
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn-warning btn-active main-action"
              @click="deleteQueue()"
            >
              {{ $t('delete') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DeleteQueue',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    serviceID: {
      type: String,
      required: true
    },
    queue: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState([
      'service',
      'currentTickets'
    ])
  },
  methods: {
    ...mapActions([
      'fetchService',
      'fetchCurrentTickets'
    ]),
    async close () {
      this.$emit('input', false)
    },
    genCharArray (charA, charZ) {
      let a = []
      let i = charA.charCodeAt(0)
      let j = charZ.charCodeAt(0)
      for (; i <= j; ++i) {
        a.push(String.fromCharCode(i))
      }
      return a
    },
    async deleteQueue () {
      await api.deleteQueue({ service: this.serviceID, queueSlug: this.queue.letter })
      await this.fetchService(this.serviceID)
      await this.fetchCurrentTickets(this.serviceID)
      this.close()
    }
  }
}
</script>
